<script>
import { Bar } from 'vue-chartjs'
 
export default {
  extends: Bar,
  mounted () {
    this.renderChart({
      labels: ['Urbanas', 'Rurais'],
      datasets: [
        {
          label: 'Escolas',
          backgroundColor: ['#ff6384', '#4bc0c0'],
          // data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11],
          data: [42, 3],
        },
      ],
    }, {
      scales: {
        xAxes:[{
         barPercentage: 0.3,
        }]
      },
      options: { 
        responsive: true, 
      },
      legend: {
        display: false
      },
    })
  }
}
</script>

<style>

</style>
